import http from '@/http'

const URL = '/admin/settings/wa/autoresponder'

export const listRules = () => http.get(URL)
export const listRuleTemplates = () => http.get(URL + '/templates')
export const createRule = (payload) => http.post(URL, payload)
export const updateRule = (id, payload) => http.put(URL + `/${id}`, payload)
export const toggleRule = (id) => http.put(URL + `/${id}/status`)
export const deleteRule = (id) => http.delete(URL + `/${id}`)

export default {
  listRules,
  listRuleTemplates,
  createRule,
  updateRule,
  toggleRule,
  deleteRule
}
